import Head from "next/head";
import { COMPANY_DETAILS } from "@vahak/core/dist/constants/companyDetails";
import { COMPANY_SOCIAL_MEDIA_CHANNELS } from "@vahak/core/dist/constants/socialMediaLinks";

export const GLOBAL_ORGANIZATION_SCHEMA_JSON = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: COMPANY_DETAILS.name,
    url: COMPANY_DETAILS.website,
    logo: COMPANY_DETAILS.logo,
    description:
        "India's largest online truck and load booking marketplace connecting shippers with verified transporters.",
    foundingDate: "2020",
    sameAs: Object.values(COMPANY_SOCIAL_MEDIA_CHANNELS),
    contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        availableLanguage: ["English", "Hindi"],
        url: COMPANY_DETAILS.website + "/contact-us"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: COMPANY_DETAILS.addressLocality,
        addressRegion: COMPANY_DETAILS.addressRegion,
        addressCountry: COMPANY_DETAILS.addressCountry
    }
});

export const OrganizationSchemaScript = () => (
    <script
        type="application/ld+json"
        id="jsonld-organization"
        dangerouslySetInnerHTML={{ __html: GLOBAL_ORGANIZATION_SCHEMA_JSON }}
    />
);

/** Site-wide Organization JSON-LD — prefer inlining {@link OrganizationSchemaScript} inside a Head block. */
const HomePageMetaScript = () => (
    <Head>
        <OrganizationSchemaScript />
    </Head>
);

export default HomePageMetaScript;
